<template>
  <project-base :state="state">
    <!-- Progress Report -->
    <progress-report
      :can-edit="canEdit"
      :monitoring="state.monitoring"
      :is-monitor="isMonitor"
    />

    <!-- Forecast Summary Chart -->
    <forecast-summary-chart
      :forecast="forecast"
      :for-version="currentForecastToShow"
      :intervention-rate="state.competition.max_partner_grant_intervention_rate || 100"
    />

    <!-- Forecast Matrix -->
    <forecast-matrix
      :can-edit="canEdit && !forecast.initials_completed"
      :forecast="forecast"
      :for-version="currentForecastToShow"
      :project-id="state.project.uuid"
      :project-partner-id="projectPartner.competition_project_partner_id"
      :intervention-rate="state.competition.max_partner_grant_intervention_rate || 100"
      @submitted="updateForecast"
    />
  </project-base>
</template>
<script>
import { userProjectMixin, userProjectNameLookupMixin } from '../mixins/userProject'
export default {
  name: 'ProjectView',
  mixins: [userProjectMixin, userProjectNameLookupMixin],
  data() {
    return {
      forecast: {},
    }
  },
  computed: {
    initialForecast() {
      return this.forecast.initials || {};
    },
    revisionForecast() {
      return this.forecast.revisions || {};
    },
    actualsForecast() {
      return this.forecast.actuals || {};
    },
    currentForecastToShow() {
      const hasInitials = this.forecast.initials_completed ?? false;
      const currentRevision = this.forecast.current?.revision || 0;
      const hasSubmittedCurrent = this.forecast.current?.submitted ?? false;

      if (!hasInitials) {
        return 0;
      }

      if (hasInitials && !hasSubmittedCurrent) {
        return currentRevision - 1;
      }

      return currentRevision;
    },
  },
	created() {
    window._project = this.project.uuid;
    document.title = `Project ${ this.state.project.ref } Overview :: ${document.title}`;
    this.forecast = Object.assign({}, this.state.forecast);
	},
  methods: {
    updateForecast(data) {
      this.forecast = Object.assign(this.forecast, data);
    },
  },
}
</script>
